import React from "react";

import { usePageTracker } from "../../../utils/googleAnalytics";
import InterviewDetailsWrapper from "../../components/InterviewDetails/InterviewDetailsWrapper";
import { DefaultPageLayout } from "../../layouts";

const InterviewPage: React.FC = () => {
  usePageTracker("call_details");

  return (
    <DefaultPageLayout>
      <InterviewDetailsWrapper />
    </DefaultPageLayout>
  );
};

export default InterviewPage;
